export const splitMarkdownAndComments = (
  part: string
): {
  before: string;
  code: string;
  after: string;
} => {
  if (
    part.trim().toLowerCase().startsWith('@prefix ') ||
    part.trim().toLowerCase().startsWith('# ')
  ) {
    // sometimes it doesn't actually put the ticks?
    return { before: '', code: part.trim(), after: '' };
  }

  const posOfTicksStart = part.indexOf('```');
  const posOfCodeStart =
    posOfTicksStart !== -1 ? part.indexOf('\n', posOfTicksStart + 3) : -1;
  if (posOfTicksStart !== -1 && posOfCodeStart !== -1) {
    const before = part.slice(0, posOfTicksStart).trim();
    const posOfCodeEnd = part.indexOf('```', posOfCodeStart);

    if (posOfCodeEnd !== -1) {
      const code = part.slice(posOfCodeStart, posOfCodeEnd).trim();
      const after = part.slice(posOfCodeEnd + 3).trim();
      return { before, code, after };
    }
    const code = part.slice(posOfCodeStart).trim();
    return { before, code, after: '' };
  }

  return { before: part.replace(/^```$/gm, '').trim(), code: '', after: '' };
};
